/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Notification destination of the notification rule, like Slack or emails
 */
export type PublicNotificationDestinationReferenceDto = {
    type: PublicNotificationDestinationReferenceDto.type;
};

export namespace PublicNotificationDestinationReferenceDto {

    export enum type {
        SLACK = 'SLACK',
        MAIL = 'MAIL',
        MS_TEAMS = 'MS_TEAMS',
        WEBHOOK = 'WEBHOOK',
    }


}
